var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageOrganisationFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00391 26V3.5C6.00391 3.1625 6.00391 2.8125 6.09141 2.475C6.16792 2.13828 6.33732 1.82977 6.58037 1.58451C6.82343 1.33924 7.1304 1.16705 7.46641 1.0875C7.82891 1 9.41641 1 9.75391 1H18.5039C18.8414 1 19.1914 1 19.5289 1.0875C19.8656 1.16401 20.1741 1.33341 20.4194 1.57647C20.6647 1.81952 20.8369 2.12649 20.9164 2.4625C21.0039 2.8125 21.0039 3.1625 21.0039 3.5V26H6.00391Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00278 16V23.5C1.00278 24.875 2.12778 26 3.50278 26H6.00278V13.5H3.50278C3.16528 13.5 2.81528 13.5 2.47778 13.5875C2.14028 13.675 1.82778 13.8375 1.57778 14.0875C1.34028 14.325 1.17778 14.6375 1.09028 14.975C1.01972 15.3119 0.990335 15.6561 1.00278 16Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5289 9.83735C24.192 9.76679 23.8479 9.73741 23.5039 9.74985H21.0039V25.9998H23.5039C24.1669 25.9998 24.8028 25.7365 25.2717 25.2676C25.7405 24.7988 26.0039 24.1629 26.0039 23.4998V12.2498C26.0039 11.8998 26.0039 11.5623 25.9164 11.2248C25.8289 10.8873 25.6664 10.5748 25.4164 10.3248C25.1789 10.0873 24.8664 9.92485 24.5289 9.83735Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0039 6H16.0039",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0039 11H16.0039",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0039 16H16.0039",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0039 21H16.0039",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageOrganisationFilled);
export default __webpack_public_path__ + "static/media/manage_organisation_filled.a4c279b4b9bdd9278b587734af32fca8.svg";
export { ForwardRef as ReactComponent };